import { fetchClient } from "checkout-query-client/api/fetch-client";

import { DeletePaymentProfilePaymentMethodRequest } from "frontend-client";

interface Params {
  paymentMethodId: string;
  apiHost: string;
  version: string;
  checkoutSessionToken: string;
}

export const deleteSavedPaymentMethod = async ({
  apiHost,
  version,
  paymentMethodId,
  checkoutSessionToken,
}: Params) => {
  const request = new DeletePaymentProfilePaymentMethodRequest({
    paymentMethodId,
  });
  return await fetchClient({
    apiHost,
    version,
  }).deletePaymentProfilePaymentMethod(request, {
    headers: {
      Authorization: "Bearer " + checkoutSessionToken,
    },
  });
};
